import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

function StreamSettings(props) {
    const { t } = useTranslation();
    return (
        <div className="stream-settings-container">
            <Typography variant="h2" className="stream-settings-title">{t('header.stream_modal.stream_setting')}</Typography>
        </div>
    );
}

export default StreamSettings;